import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Enrollment } from './enrollment.model';
import { EnrollmentPopupService } from './enrollment-popup.service';
import { EnrollmentService } from './enrollment.service';
import { School, SchoolService } from '../school';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { SubscriptionType, SubscriptionTypeService } from '../subscription-type';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { SchoolCalendar, SchoolCalendarService} from '../school-calendar';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-enrollment-dialog',
    templateUrl: './enrollment-dialog.component.html'
})
export class EnrollmentDialogComponent extends AbstractDialogComponent implements OnInit {

    enrollment: Enrollment;
    authorities: any[];
    isSaving: boolean;

    students: Student[];
    currentSchoolCalendar: SchoolCalendar = new SchoolCalendar();

    subscriptiontypes: SubscriptionType[];

    search = this.studentTypeaheadService.search;

    resultFormatter = this.studentTypeaheadService.resultFormatter;

    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.enrollment.student['user']);

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private enrollmentService: EnrollmentService,
        schoolService: SchoolService,
        private studentService: StudentService,
        private subscriptionTypeService: SubscriptionTypeService,
        private eventManager: EventManager,
        private studentTypeaheadService: StudentTypeaheadService,
        private schoolCalendarService: SchoolCalendarService,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.isSaving = false;
        if (this.enrollment.validUntil instanceof Date) {
            this.enrollment.validUntil = {
                year: this.enrollment.validUntil.getFullYear(),
                month: this.enrollment.validUntil.getMonth() + 1,
                day: this.enrollment.validUntil.getDate()
            };
        }
        if (this.enrollment.validSince instanceof Date) {
            this.enrollment.validSince = {
                year: this.enrollment.validSince.getFullYear(),
                month: this.enrollment.validSince.getMonth() + 1,
                day: this.enrollment.validSince.getDate()
            };
        }
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.subscriptionTypeService.query().subscribe(
            (res: HttpResponse<SubscriptionType[]>) => { this.subscriptiontypes = res.body; },
            (res: HttpErrorResponse) => this.onError(res));
        this.loadSchools();
        this.loadCurrentCalendar();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.enrollment.student instanceof Object) {
            this.isSaving = true;
            if (this.enrollment.id !== undefined) {
                this.enrollmentService.update(this.enrollment)
                    .subscribe((res: Enrollment) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
            } else {
                this.enrollmentService.create(this.enrollment)
                    .subscribe((res: Enrollment) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
            }
        } else {
            let studentInput = form !== undefined ? form.controls['student'] : null;
            if (studentInput !== null) {
                studentInput.reset();
            }
        }
    }

    public showCurrentCalendarWarning() {
        return this.currentSchoolCalendar === null;
    }

    private loadCurrentCalendar() {
        this.principal.hasAnyAuthority(['ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ])
        .then(response => {
            if (response) {
                this.schoolCalendarService
                .current()
                .subscribe(
                    (res: HttpResponse<SchoolCalendar[]>) => {
                        let calendars = res.body;
                        if (calendars.length > 0 ) {
                            this.currentSchoolCalendar = calendars[0];
                            if (!this.enrollment.id) {
                                this.enrollment.validUntil =  {
                                    year: this.currentSchoolCalendar.ending.getFullYear(),
                                    month: this.currentSchoolCalendar.ending.getMonth() + 1,
                                    day: this.currentSchoolCalendar.ending.getDate()
                                };
                            }
                        } else {
                            this.currentSchoolCalendar = null;
                        }

                    },
                    (res: HttpErrorResponse) => this.onError(res));
            }
        });
    }

    onSubscriptionTypeChange(subscriptionType: SubscriptionType) {
        this.enrollment.price = subscriptionType.price;
     }

    private onSaveSuccess(result: Enrollment, action: string) {
        this.eventManager.broadcast({ name: 'enrollmentListModification',  content: {
            action: action,
            content: result
        } });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackSubscriptionTypeById(index: number, item: SubscriptionType) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-enrollment-popup',
    template: ''
})
export class EnrollmentPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private enrollmentPopupService: EnrollmentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.enrollmentPopupService
                    .open(EnrollmentDialogComponent as Component, params['id']);

            } else if (params['studentId']) {
                this.modalRef = this.enrollmentPopupService
                    .open(EnrollmentDialogComponent as Component, undefined, params['studentId']);
            } else {
                this.modalRef = this.enrollmentPopupService
                    .open(EnrollmentDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment-dialog.component.ts